import { ApiClient } from "@/api-client/src/core/api-client";
import { ApiResponse, City, Country, State } from "@/packages/types/address";

const apiClient = new ApiClient();
const webService = apiClient.web;
export const fetchAllCountries = async (): Promise<ApiResponse<Country>> => {
  const response = await webService.get<ApiResponse<Country>>(`/countries`);
  return response;
};
export const fetchAllStates = async (
  countryId: string
): Promise<ApiResponse<State>> => {
  const response = await webService.get<ApiResponse<State>>(
    `/countries/${countryId}/states`
  );
  return response;
};
export const fetchAllCities = async (
  countryId: string,
  stateId: string
): Promise<ApiResponse<City>> => {
  const response = await webService.get<ApiResponse<City>>(
    `/countries/${countryId}/states/${stateId}/cities`
  );
  return response;
};
